import { useDispatch, useSelector } from "react-redux";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../Components/InputAHSF";
import { useEffect, useState } from "react";
import $ from "jquery";

import {
  BudgetItemsList,
  BudgetItemsListToFilter,
} from "../../../Redux/Reducers/ReportStage/BudgetItems";
import {
  AddTransferRequestDetails,
  TransferRequestValidation,
} from "../../../Redux/Reducers/ReportStage/TransferRequestDetails";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import Swal from "sweetalert2";

const TransferRequestDetailsForm = (props) => {
  const BudgetItemsListd = useSelector(
    (state) => state.BudgetItems.BudgetItemsList
  );
  const BudgetItemsListTo = useSelector(
    (state) => state.BudgetItems.BudgetItemsListTo
  );
  const [ItemTransferredFrom, setItemTransferredFrom] = useState(null);
  const [ItemTransferredTo, setItemTransferredTo] = useState(null);
  const [RequiredValue, setRequiredValue] = useState(null);
  const [TransferValidation, setTransferValidation] = useState(false);
  const dispatch = useDispatch();

  const Validation = () => {
    const isFromEmpty = !ItemTransferredTo;
    const isToEmpty = !ItemTransferredFrom;
    const isRequiredValueEmpty = !RequiredValue || RequiredValue.trim() === "";

    const hasError = isFromEmpty || isToEmpty || isRequiredValueEmpty;
    setTransferValidation(hasError);

    return !hasError;
  };

  useEffect(() => {
    dispatch(
      BudgetItemsList({
        reportId: props.reportId,
      })
    );
  }, [props.reportId]);
  // console.log(BudgetItemsListd, "BudgetItemsList");
  const AddTransferRequestDetailsFunction = async () => {
    const result = await dispatch(
      TransferRequestValidation({
        itemToTransferFrom: ItemTransferredFrom,
        itemToTransferTo: ItemTransferredTo,
        actualSpend: RequiredValue,
      })
    );

    // console.log(result?.payload.length, "sssssssssssssdwdwd");
    if (result?.payload?.length > 0) {
      Swal.fire({
        title: "الرجاء تعبئة الحقول التالية",
        html: `
                                                  <div style="text-align: right; direction: rtl; font-size: 16px;">
                                                    <ul style="list-style-type: none; padding: 0;">${result?.payload
                                                      .map(
                                                        (field) =>
                                                          `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                                                      )
                                                      .join("")}</ul>`,
        icon: "warning",
        confirmButtonText: "حسناً",
      });
    } else {
      dispatch(
        AddTransferRequestDetails({
          itemToTransferFrom: ItemTransferredFrom,
          itemToTransferTo: ItemTransferredTo,
          projectModificationRequestsId: props.projectModificationRequestsId,
          requestedAmount: RequiredValue,
        })
      );
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تمت الأضافة بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });

      $(".close-btn").trigger("click");
    }

    // if (Validation()) {

    // }
  };
  return (
    <>
      <div className="AddEdite">
        <AllDropDownsAHSF
          fieldsName="ItemTransferredFrom"
          show={true}
          // disabled={shouldDisableFields}
          KeyText={"itemName"}
          KeyValue={"budgetItemsId"}
          arrayOoptionList={BudgetItemsListd}
          dropdownType={"normal"}
          onChange={(e) => {
            dispatch(BudgetItemsListToFilter(e.target.value));
            setItemTransferredFrom(e.target.value);
          }}
          showValidationMessage={TransferValidation && !ItemTransferredFrom}
          validationMessage="يرجى تعبئة هذا الحقل"
        />

        <AllDropDownsAHSF
          fieldsName="ItemTransferredTo"
          show={true}
          // disabled={shouldDisableFields}
          KeyText={"itemName"}
          KeyValue={"budgetItemsId"}
          arrayOoptionList={BudgetItemsListTo}
          dropdownType={"normal"}
          onChange={(e) => {
            setItemTransferredTo(e.target.value);
          }}
          showValidationMessage={TransferValidation && !ItemTransferredTo}
          validationMessage="يرجى تعبئة هذا الحقل"
        />

        <InputAHSF
          fieldsName="RequiredValue"
          show={true}
          disabled={false}
          comma={true}
          onChange={(e) => {
            setRequiredValue(e.target.value);
          }}
          // defaultValue={
          //   props.Action == "edit"
          //     ? ActivitiesForStageList?.rS_NT_Activities?.activitiesName
          //     : ""
          showValidationMessage={
            TransferValidation &&
            (!RequiredValue || RequiredValue.trim() === "")
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />

        <div className="containersButton">
          <div>
            <ButtonAHSF
              type={"submitter"}
              onClick={AddTransferRequestDetailsFunction}
              disabled={false}
              title={props.canEdit == "edit" ? "تعديل" : "إضافة"}
              text={props.canEdit == "edit" ? "تعديل" : "إضافة"}
              show={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TransferRequestDetailsForm;
